<template>
  <v-col cols="3" class="sidebar-col">
    <SettingsSectionCard
      icon="fal fa-sliders-h"
      :title="$t('setting')"
      accent
      class="sticky-card"
      body-class="pa-0"
    >
      <v-list flat>
        <v-list-item-group
          v-model="selectedItem"
          color="primary"
          mandatory
          active-class="text-primary"
        >
          <template v-for="(item, index) in items">
            <v-list-item
              class="pr-0"
              :key="item.text"
              @click="$emit('handle', item.value)"
              dense
            >
              <v-list-item-avatar
                class="rounded-lg grey--text text--lighten-4"
                size="35"
              >
                <v-icon
                  small
                  :color="selectedItem === index ? 'primary' : 'grey'"
                  >far fa-{{ item.icon }}</v-icon
                >
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ $t(item.text) }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action
                class="px-0"
                v-if="!$vuetify.breakpoint.mobile"
              >
                <v-switch
                  v-if="item.text === 'dark_mode'"
                  color="primary"
                  v-model="darkMode"
                  hide-details
                  @change="$emit('handle', item.value)"
                  @click.stop="handleClick(item.value)"
                  inset
                />

                <v-icon
                  small
                  :color="selectedItem === index ? 'primary' : 'grey'"
                  v-else
                  >fal fa-angle-right</v-icon
                >
              </v-list-item-action>
            </v-list-item>
            <v-divider
              inset
              class="my-0"
              v-if="index < items.length - 1"
              :key="index"
            ></v-divider>
          </template>
        </v-list-item-group>
      </v-list>
      <div class="settings-version">{{ $t("version") }} : {{ version }}</div>
    </SettingsSectionCard>
  </v-col>
</template>

<script>
import SettingsSectionCard from "@/components/settings/SettingsSectionCard.vue";

export default {
  components: {
    SettingsSectionCard,
  },
  props: ["items", "value"],
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
      darkMode: this.value,
      selectedItem: 0,
    };
  },
  mounted() {
    const savedValue = localStorage.getItem("selectedItem");
    if (savedValue !== null) {
      const idx = this.items.findIndex(
        (item) => String(item.value) === savedValue,
      );
      if (idx !== -1) this.selectedItem = idx;
    }
  },
  destroyed() {
    localStorage.removeItem("selectedItem");
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) this.darkMode = newVal;
    },
    darkMode(newVal, oldVal) {
      if (newVal !== oldVal) this.$emit("input", newVal);
    },
  },
};
</script>

<style scoped>
.sidebar-col {
  position: relative;
}

.sidebar-col .v-list-item__title {
  font-weight: 400;
}

.sidebar-col .v-list-item--active .v-list-item__title {
  color: var(--v-primary-base) !important;
}

.sticky-card {
  position: sticky;
  top: 80px;
  max-height: calc(100vh - 100px);
  overflow-y: auto;
}

/* Custom scrollbar */
.sticky-card::-webkit-scrollbar {
  width: 4px;
}

.sticky-card::-webkit-scrollbar-track {
  background: transparent;
}

.sticky-card::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}

.sticky-card::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.2);
}

/* ---- Version footer (moved here from the app bar / sidebar) ---- */
.settings-version {
  padding: 12px 16px;
  border-top: 1px solid #e2e8f0;
  font-size: 11px;
  font-weight: 400;
  color: #94a3b8;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.theme--dark .settings-version {
  border-top-color: #2f333a;
  color: rgba(148, 163, 184, 0.7);
}
</style>
